/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ApiKeyFull: core.serialization.ObjectSchema<serializers.ApiKeyFull.Raw, Truvity.ApiKeyFull> =
    core.serialization.object({
        expiration: core.serialization.date(),
        secret: core.serialization.string(),
        subjectId: core.serialization.property('subject_id', core.serialization.string()),
    });

export declare namespace ApiKeyFull {
    export interface Raw {
        expiration: string;
        secret: string;
        subject_id: string;
    }
}
